import { useCallback } from 'react';
import { useAppSelector, useAppDispatch } from '@/services/redux/hook';
import { toggleBalanceVisibility as toggleBalanceVisibilityAction, setBalanceVisibility } from '@/services/redux/slices/balance-visibility/balance-visibility';

interface UseBalanceVisibilityReturn {
  isBalanceHidden: boolean;
  toggleBalanceVisibility: () => void;
  hideBalance: () => void;
  showBalance: () => void;
}

/**
 * Custom hook for managing balance visibility across the application
 * Uses Redux for state management and automatically persists to storage
 * Provides a consistent way to hide/show balances in multiple components
 */
export const useBalanceVisibility = (): UseBalanceVisibilityReturn => {
  const isBalanceHidden = useAppSelector((state) => state.balanceVisibility.isHidden);
  const dispatch = useAppDispatch();

  const toggleBalanceVisibility = useCallback(() => {
    dispatch(toggleBalanceVisibilityAction());
  }, [dispatch]);

  const hideBalance = useCallback(() => {
    dispatch(setBalanceVisibility(true));
  }, [dispatch]);

  const showBalance = useCallback(() => {
    dispatch(setBalanceVisibility(false));
  }, [dispatch]);

  return {
    isBalanceHidden,
    toggleBalanceVisibility,
    hideBalance,
    showBalance,
  };
};

export default useBalanceVisibility;